import { baseUrlCollaboration as collaboration } from "./endpoints";
import { Endpoint } from "lib/types/Endpoint";

export const endpointsIssues = {
  projectIssues: (projectId: number): string =>
    `${collaboration}/project/${projectId}/issue/query?isDeleted=false`,
  projectIssuesTags: (projectId): string =>
    `${collaboration}/project/${projectId}/issue/tags`,
  projectIssueTypes: (projectId: number): string =>
    `${collaboration}/project/${projectId}/issue/types`,
  projectIssueUsers: (projectId: number): string =>
    `${collaboration}/project/${projectId}/issue/connector/users`,
  projectIssueCreate: (projectId: number): Endpoint => ({
    method: "POST",
    url: `${collaboration}/project/${projectId}/issue`,
  }),
  projectIssueUpdate: (projectId: number, issueId: string): Endpoint => ({
    method: "PATCH",
    url: `${collaboration}/project/${projectId}/issue/${issueId}`,
  }),
  projectIssueDelete: (projectId: number, issueId: string): Endpoint => ({
    method: "DELETE",
    url: `${collaboration}/project/${projectId}/issue/${issueId}`,
  }),
  comments: (projectId: number, issueId: string) =>
    `${collaboration}/project/${projectId}/issue/${issueId}/comments`,
  createComment: (projectId: number, issueId: string) =>
    ({
      url: `${collaboration}/project/${projectId}/issue/${issueId}/comments`,
      method: "POST",
    }) as Endpoint,
  patchComment: (projectId: number, issueId: string, commentId: string) =>
    ({
      url: `${collaboration}/project/${projectId}/issue/${issueId}/comments/${commentId}`,
      method: "PATCH",
    }) as Endpoint,
  removeComment: (projectId: number, issueId: string, commentId: string) =>
    ({
      url: `${collaboration}/project/${projectId}/issue/${issueId}/comments/${commentId}`,
      method: "DELETE",
    }) as Endpoint,
  templates: (projectId: number) =>
    `${collaboration}/project/${projectId}/issue/templates`,
  createTemplate: (projectId: number) =>
    ({
      url: `${collaboration}/project/${projectId}/issue/templates`,
      method: "POST",
    }) as Endpoint,
  updateTemplate: (projectId: number, templateId: string) =>
    ({
      url: `${collaboration}/project/${projectId}/issue/templates/${templateId}`,
      method: "PATCH",
    }) as Endpoint,
  deleteTemplate: (projectId: number, templateId: string) =>
    ({
      url: `${collaboration}/project/${projectId}/issue/templates/${templateId}`,
      method: "DELETE",
    }) as Endpoint,
};
